import settings from '../settings';

/* eslint no-underscore-dangle: 0 */

/**
 * @private
 */
const _YMD = (/[yMd]+/gi);
const _Y = (/y+/);
const _M = (/M+/);
const _D = (/d+/);
const _YY = (/^YY$/);
const _YYYY = (/^YYYY$/);
const _MONTH = (/^M$/);
const _MMONTH = (/^MM$/);
const _MMMONTH = (/^MMM$/);
const _MMMMONTH = (/^MMMM$/);
const _DAY = (/^D$/);
const _DDAY = (/^DD$/);
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * @private
 */
const defaults = {
  date: null,
  inputFormat: 'yyyy/MM/dd',
  outputFormat: settings.defaults.dateFormat,
};

/**
 * @public
 * Changes the format of a string-date.
 *
 * @see https://gist.github.com/jherax/e58ee9f560764a72a90ded5fc53e4105
 *
 * @param  {Object|String} options: it can be a String with the date, or an Object with the following properties:
 *         - {String} date: the entry date to change the format
 *         - {String} inputFormat: the format of the entry date
 *         - {String} [outputFormat='MM/dd/yyyy']: the format of the output date
 * @return {String}
 */
export default function formatDate(options) {
  let d, m, y;
  if (typeof options === 'string') {
    options = {date: options};
  }
  const opt = Object.assign({}, defaults, options);
  const dateParts = opt.date.split(/\D/);
  const formatParts = opt.inputFormat.split(/\W/);
  for (let i = 0; i < formatParts.length; i += 1) {
    if (_Y.test(formatParts[i])) { y = dateParts[i]; continue; }
    if (_M.test(formatParts[i])) { m = dateParts[i]; continue; }
    if (_D.test(formatParts[i])) { d = dateParts[i]; continue; }
  }
  return opt.outputFormat.replace(_YMD, (match) => { // eslint-disable-line
    if (_YY.test(match)) return y.slice(2);
    if (_YYYY.test(match) || _Y.test(match)) return y;
    if (_MONTH.test(match)) return +m;
    if (_MMMMONTH.test(match)) return monthNames[+m - 1];
    if (_MMMONTH.test(match)) return monthNames[+m - 1].slice(0, 3);
    if (_MMONTH.test(match) || _M.test(match)) return m;
    if (_DAY.test(match)) return +d;
    if (_DDAY.test(match) || _D.test(match)) return d;
  });
}
